import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaEdit } from "react-icons/fa";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";

const API = process.env.REACT_APP_API_BASE_URL;

interface Affiliate {
  id: number;
  name: string;
  email: string;
  phone: string;
  affiliate_code: string;
  status: string;
  total_orders: number;
  total_revenue: number;
  total_commission: number;
}

export default function PenjualanAffiliatePage() {
  const [affiliates, setAffiliates] = useState<Affiliate[]>([]);
  const [selectedAffiliate, setSelectedAffiliate] = useState<Affiliate | null>(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchAffiliates = async () => {
    try {
      const token = Cookies.get("token");

      const res = await axios.get(`${API}/api/admin/affiliates`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
        },
      });

      setAffiliates(res.data.data);
      setTotalPages(res.data.last_page);
    } catch {
      Swal.fire("Error", "Gagal mengambil data affiliate", "error");
    }
  };

  useEffect(() => {
    fetchAffiliates();
  }, [page]);

  return (
    <div className="mt-7">
      {/* HEADER */}
      <h1 className="text-2xl font-bold mb-6">Hasil Penjualan Affiliate</h1>

      {/* TABLE */}
      <div className="bg-white rounded-xl shadow border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3 text-left">Nama</th>
              <th className="p-3 text-left">Email</th>
              <th className="p-3 text-left">Phone</th>
              <th className="p-3 text-left">Code</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-left">Orders</th>
              <th className="p-3 text-left">Revenue</th>
              <th className="p-3 text-left">Commission</th>
              <th className="p-3 text-center">Aksi</th>
            </tr>
          </thead>

          <tbody>
            {affiliates.map((a) => (
              <tr key={a.id} className="border-t">
                <td className="p-3">{a.name}</td>
                <td className="p-3">{a.email}</td>
                <td className="p-3">{a.phone}</td>
                <td className="p-3 font-mono">{a.affiliate_code}</td>

                <td className="p-3">
                  <span className={`px-2 py-1 rounded text-xs ${a.status === "approved" ? "bg-green-100 text-green-700" : "bg-yellow-100 text-yellow-700"}`}>{a.status}</span>
                </td>

                <td className="p-3">{a.total_orders}</td>
                <td className="p-3">Rp {new Intl.NumberFormat("id-ID").format(Number(a.total_revenue))}</td>

                <td className="p-3">Rp {new Intl.NumberFormat("id-ID").format(Number(a.total_commission))}</td>

                <td className="p-3 flex justify-center">
                  <Link to={`/dashboard/affiliate/penjualan/detail/${a.id}`}>
                    <button className="text-blue-500 hover:text-blue-700">Detail</button>
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      <div className="flex justify-end gap-2 mt-4">
        {[...Array(totalPages)].map((_, i) => (
          <button key={i} onClick={() => setPage(i + 1)} className={`px-3 py-1 rounded ${page === i + 1 ? "bg-primary text-white" : "bg-gray-200"}`}>
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
}
